// import 'antd/dist/antd.css';
import 'antd/dist/antd.variable.min.css';
import 'src/styles/global.css';

import React from 'react';

import MainApp from './main-app';
import store from './src/config/storeRedux';

export const wrapRootElement = ({ element }) => {
  return <MainApp reduxStore={store()}>{element}</MainApp>;
};
